// extracted by mini-css-extract-plugin
export default {"plans":"Plans_plans__C6aSv","tables":"Plans_tables__vD8nG","table":"Plans_table__-XaRg"};